/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:require('./Input'),
    method:{
        init:function () {

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/form/InputWithLabel.js
// module id = 74
// module chunks = 4 6 32 35 36